import React, { useEffect, useReducer } from "react";
import { Button, Form, message } from "antd";
import { useHistory } from "react-router-dom";
import ComponentsBreadcrumb from "../../layout/componentsBreadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { formReducer,formState } from "./reducer";
import { useSendTransaction } from "wagmi";
import { SavePendingCommisionDetailes } from "./service";
import { fetchNetworks, setPendingComisionSaveData } from "../../reducers/transferReducer";
import { isErrorDispaly } from "../../shared/validationsAndExceptions/apiExceptions";
import AppAlert from "../../shared/appAlert";
import useSwitchNetwork from "../../shared/useSwitchNetwork";
import { arcanaAuth } from "../../auth/web3Config";
import { parseEther } from "viem";
import Loader from "../../shared/loader";
const toAddress = process.env.REACT_APP_OWNER_ACCOUNT_WALLET_ADDRESS

const PendingCommissions = () => {
  const history = useHistory()
  const commisionsData = useSelector((store) => store.trasferReducer.commissionDetails);
  const customerInfo = useSelector((store) => store.userConfig.userProfileInfo);
  const [localState, localDispatch] = useReducer(formReducer, formState);
  const reducerDispatch = useDispatch();
  const { switchNetwork } = useSwitchNetwork();  
  const networkLookup = useSelector((store) => store.trasferReducer?.networkLookup);
  const chainId = arcanaAuth?.provider?.chainId;

  const {
    data: 
    isPending,isLoading,
    sendTransactionAsync
  } = useSendTransaction()
  const breadCrumbList = [
    { id: '1', bname: 'Dashboard', url: '/dashboard' },
    { id: '2', bname: 'Commissions' }
  ];
  useEffect(()=>{
    if(commisionsData?.data){
      reducerDispatch(fetchNetworks(commisionsData?.data?.coin, customerInfo?.id))
    }
  },[commisionsData?.data])
  useEffect(() => {
    if(networkLookup?.data && commisionsData?.data){
      const selectedNetworkId = networkLookup.data?.find(network => network.name == commisionsData?.data?.network);
      localDispatch({ type: 'setSelectedNetwork', payload: selectedNetworkId });
    }
  }, [networkLookup?.data]);
  const navigation=()=>{
    history.push('/dashboard');
  }
  const handleCreate = async () => {
    let saveObj = {
      "customerId": customerInfo?.id,
      "commissionAmount":commisionsData?.data?.commissionAmount,
      "fromAddress": commisionsData?.data?.fromAddress,
      "network": commisionsData?.data?.network,
      "coin": commisionsData?.data?.coin,
    }
    try{
      localDispatch({ type: 'setErrors', payload: null });
      localDispatch({ type: 'setIsLoading', payload: 'btnLoader' });

      let switchNetErr
        if (![localState?.selectedNetwork?.hexId, localState?.selectedNetwork?.chainId].includes(chainId?.toString())) {
          switchNetErr = await switchNetwork(localState?.selectedNetwork?.chainId);
        }
      if (switchNetErr) {
        localDispatch({ type: 'setErrors', payload: switchNetErr });
        return;
      }
      localDispatch({ type: 'setErrors', payload: null });
     const transferDetailesData = await sendTransactionAsync({
        to: toAddress,
        value: parseEther(saveObj.commissionAmount.toString()),
      });
      if(transferDetailesData?.hash){
        let response = await SavePendingCommisionDetailes('/Merchant/savependingcommissions', saveObj);
        if (response?.ok) {
          let _obj = {...saveObj}
          reducerDispatch(setPendingComisionSaveData(_obj));
          message.success({
            content: "Transfered successfully!",
            className: 'custom-msg',
            duration: 1
          });
          setTimeout(()=>{
            history.push('/transfer')
          },2000);
        }else{
          localDispatch({ type: 'setErrors', payload: isErrorDispaly(response) });
          return;
        }
      }
    }
    catch(error){
      localDispatch({ type: 'setErrors', payload: isErrorDispaly(error) });
      localDispatch({ type: 'setIsLoading', payload: '' });
    }finally{
      localDispatch({ type: 'setIsLoading', payload: '' });
    }
  }
  const clearError=(val)=>{
      localDispatch({ type: 'setErrors', payload: val });
  }
  
  return (
    <>
      <ComponentsBreadcrumb breadCrumbList={breadCrumbList} />
      
      <div className="layout-bg right-panel panel-bg tracnsaction-details">
          <div className="trans-card">
          {localState.errors && (
            <div className="alert-flex" style={{ width: "100%",padding:16 }}>
                <AppAlert
                    className="w-100 "
                    type="warning"
                    description={localState.errors}
                    showIcon
                    closable
                    onClick={() =>clearError(null) }
                />
            </div>
          )}
            <div className="d-flex align-items-center">
              <span className="icon lg btn-arrow-back c-pointer" onClick={navigation}></span>
              <p className="card-title card-head">Commissions</p>
            </div>
            {networkLookup?.isLoading && <Loader/>}
            {!networkLookup?.isLoading && <> 
            <Form
              className="summary-content tx-space transaction-summary"
              scrollToFirstError
            >
              <div className="mt-30">
               <div className="summary-list-item">
                <p className="summary-label">From address</p>
                <p className="summary-text"> {commisionsData?.data?.fromAddress}</p>
               </div>
               <div className="summary-list-item">
                <p className="summary-label">To address</p>
                <p className="summary-text">{toAddress}</p>
               </div>
               <div className="summary-list-item">
                <p className="summary-label">Commission amount</p>
                <p className="summary-text">{commisionsData?.data?.commissionAmount}</p>
               </div>
               <div className="summary-list-item">
                <p className="summary-label">Network</p>
                <p className="summary-text">{commisionsData?.data?.network}</p>
               </div>
               <div className="summary-list-item">
                <p className="summary-label">Coin</p>
                <p className="summary-text">{commisionsData?.data?.coin}</p>
               </div>
              </div>
            </Form>
            <div className="text-right">
            <Button className="estimate-text download-btn d-flex align-items-center gap-16 mr-0 ml-auto" htmlType="submit"
             onClick={handleCreate} loading={ localState.isLoading === 'btnLoader'} disabled={ localState.isLoading === 'btnLoader'}>
              Send <span className="icon lg right-arrow c-pointer" />
            </Button>
            </div>
            </>}
          </div>
                 
        </div>
    </>
  );
};

export default PendingCommissions;
